export type ExportingStepKey =
  | "selectPostingDate"
  | "reviewRawTransactions"
  | "reviewJes"
  | "reviewGroupedJes"
  | "reviewJeExports"
  | "confirmation";

export type ExportingStep = {
  key: ExportingStepKey;
  label: string;
};

export const getExportingStepLabels = (steps: ExportingStep[]): string[] => {
  return steps.map((step) => step.label);
};

export const SelectPostingDateStep: ExportingStep = {
  key: "selectPostingDate",
  label: "selectPostingDate",
};

export const ReviewRawTransactionsStep: ExportingStep = {
  key: "reviewRawTransactions",
  label: "reviewRawTransactions",
};

export const ReviewJesStep: ExportingStep = {
  key: "reviewJes",
  label: "reviewJes",
};

export const ReviewGroupedJesStep: ExportingStep = {
  key: "reviewGroupedJes",
  label: "reviewGroupedJes",
};

export const ReviewJeExportsStep: ExportingStep = {
  key: "reviewJeExports",
  label: "reviewJeExports",
};

export const ConfirmationStep: ExportingStep = {
  key: "confirmation",
  label: "confirmation",
};

export const ExportingByPostingDateSteps: ExportingStep[] = [
  SelectPostingDateStep,
  ReviewRawTransactionsStep,
  ReviewJesStep,
  ReviewGroupedJesStep,
  ReviewJeExportsStep,
  ConfirmationStep,
];

export const OnStepExportingByPostingDateSteps: ExportingStep[] = [
  SelectPostingDateStep,
  ReviewJeExportsStep,
];
